angular.module('QoipApp').factory('QoipSoilDataFactory', function ($resource){
    return $resource('/api/qoip/fieldsoildata/');
});
